<template>
  <div>
    <v-stepper
      alt-labels
      v-model="e1"
      style="background: none; box-shadow: none"
    >
      <v-stepper-header
        style="
          height: 60px;
          align-content: center;
          width: 100%;
          float: right;
          box-shadow: none;
        "
      >
        <v-stepper-step color="green" step="" :complete="e1 != null && e1 > -1">
          Ready
        </v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step color="green" step="" :complete="e1 != null && e1 > 0">
          <span v-if="e1 != 0 || (trip && !trip.showSave)"> Started </span>

          <v-btn
            x-small
            :color="'blue lighten-2'"
            :title="$i18n.t('Start')"
            @click="showStartStopDialog = true"
            v-if="e1 == 0 && trip && trip.showSave"
          >
            Start
          </v-btn>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="" :complete="e1 != null && e1 > 1">
          <span v-if="e1 != 1 || (trip && !trip.showSave)"> Completed </span>

          <v-btn
            x-small
            :color="'blue lighten-2'"
            :title="$i18n.t('Mark Completed')"
            @click="showStartStopDialog = true"
            v-if="e1 == 1 && trip && trip.showSave"
          >
            Mark Complete
          </v-btn>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="" :complete="e1 != null && e1 > 2">
          <span v-if="e1 != 2 || (trip && !trip.showSave)"> POD Received </span>

          <v-btn
            x-small
            :color="'blue lighten-2'"
            :title="$i18n.t('Mark POD Received')"
            @click="showStartStopDialog = true"
            v-if="e1 == 2 && trip && trip.showSave"
          >
            Mark POD Rcvd
          </v-btn>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="" :complete="e1 != null && e1 > 3">
          <span v-if="e1 != 3 || (trip && !trip.showSave)"> POD Submitted </span>

          <v-btn
            x-small
            :color="'blue lighten-2'"
            :title="$i18n.t('Mark POD Submitted')"
            @click="showStartStopDialog = true"
            v-if="e1 == 3 && trip && trip.showSave"
          >
            Mark POD Sbmt
          </v-btn>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="" :complete="e1 != null && e1 > 4">
          Settled
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <trip-start-stop
      :trip="trip"
      :showSSDialog="showStartStopDialog"
      @startStopDialogClose="startStopDialogClose"
    />
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import TripStartStop from "@/views/trip/TripStartStop.vue";

@Component({
  name: "ProgressWizard",
  props: {
    label: {
      default: "Progress Wizard",
    },
    status: {
      default: null,
    },
    trip: {
      default: null,
    },
  },
  components: {
    TripStartStop,
  },
})
export default class ProgressWizard extends Vue {
  showStartStopDialog = false;
  e1 = null;

  @Watch("status")
  onStatusChange(val) {
    this.e1 = val;
  }

  startStopDialogClose(reload) {
    this.$emit("startStopDialogClose", reload);
    this.showStartStopDialog = null;
  }

  mounted() {
    this.e1 = this.status;
  }
}
</script>